import { dropdownProductValidate } from '../../application/dtos/dropdown_product_validate'

export class dropdownProductEntity {
    constructor({id, sku, type}){
        this.id = id;
        this.sku =  sku;
        this.type = type;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return dropdownProductValidate(this);
    }
}